import { FormControl, FormErrorMessage, Stack } from '@chakra-ui/react';
import Button from '@components/interactive/Button';
import TextInput from '@components/interactive/TextInput';
import Body1 from '@components/typography/Body1';
import { validateEmail } from '@utils/validateEmail';
import { Field, Form, Formik } from 'formik';
import { useState } from 'react';
import CtaWrapper from './CtaWrapper';
import { saveNewsletterEmail } from './requests';

function NewsletterSignup() {
  const [loading, setLoading] = useState(false);
  const [buttonText, setButtonText] = useState('Sign Up');
  const [email, setEmail] = useState('');

  // Pull meta data on current page / userId
  const path = typeof window === 'undefined' ? '' : window!.location.href;
  const localUser = typeof window === 'undefined' ? null : window!.localStorage.getItem('user');

  const handleSubmit = async () => {
    setLoading(!loading);
    await saveNewsletterEmail({ email, meta: { path, localUser } });

    // Artificial timeout so it doesn't look instant
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setButtonText('Confirmed.');
    setLoading(false);
    setEmail('');
  };

  const renderCta = () => (
    <Formik initialValues={{ email: '' }} onSubmit={() => handleSubmit()}>
      {() => (
        <Form>
          <Stack width="100%" spacing={5}>
            <Body1>
              Join the <i>Fair Square Medicare Newsletter</i> to stay informed on cost savings, changes to Medicare, and
              other valuable healthcare information.
            </Body1>

            <Field name="email" validate={() => validateEmail(email)}>
              {({ form }) => (
                <FormControl isInvalid={form.errors.email && form.touched.email}>
                  <TextInput
                    name="email"
                    background="white"
                    id="email"
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email"
                    required
                    type="email"
                    value={email}
                    width="100%"
                  />
                  <FormErrorMessage>{form.errors.email}</FormErrorMessage>
                </FormControl>
              )}
            </Field>
            <Button
              isDisabled={buttonText !== 'Sign Up'}
              className="newsletter_email_submit"
              isLoading={loading}
              mt="1rem"
              type="submit"
              width="100%"
            >
              {buttonText}
            </Button>
          </Stack>
        </Form>
      )}
    </Formik>
  );

  return <CtaWrapper header="Stay Up to Date on Medicare!" renderCta={renderCta} />;
}

export default NewsletterSignup;
